import { getRuntimeEnvVar } from '@/app/services/runtimeEnv';

/**
 * 불리언 플래그 — 런타임 주입(window.__ENV) → 빌드 값 순. 빌드 값은 vite.config 의 define 이
 * config/defaults 로 채우므로 기본값은 그 한 곳에만 있다(컨테이너 기본 config/defaults.sh 와 같은 값).
 * 둘 다 비어 있으면 설정이 빠진 것이다 — 조용히 켜거나 끄지 않는다.
 */
function readFlag(key: keyof ImportMetaEnv & string): boolean {
  const build = import.meta.env[key];
  const value = getRuntimeEnvVar(key, build) || build;
  if (!value) throw new Error(`${key}: 빌드에 값이 없다 — vite.config define 과 config/defaults 를 확인`);
  return value !== 'false';
}

/** /quickrun 페이지 + 진입 카드 노출 여부. */
export const QUICKRUN_ENABLED = readFlag('VITE_ENABLE_QUICKRUN');
